import { render, staticRenderFns } from "./NTPLP.vue?vue&type=template&id=68cc5be5&scoped=true&"
import script from "./NTPLP.vue?vue&type=script&lang=js&"
export * from "./NTPLP.vue?vue&type=script&lang=js&"
import style0 from "./NTPLP.vue?vue&type=style&index=0&id=68cc5be5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68cc5be5",
  null
  
)

export default component.exports